// Seat-one palette — pulls EXACT colors from the canonical dispatcher
// app (FlightTile.js, DispatchBoard.js, ConcourseMap.js, connectionUtils.js)
// so the seat-one demo lives in the same visual world as the rest of
// the app. No new colors invented here — everything maps to a hex
// already in use elsewhere.

export const C = {
  // ── Surfaces — frosted-glass card pattern from FlightDataPage ──
  surface:    'rgba(30, 30, 30, 0.7)',
  surfaceAlt: 'rgba(30, 30, 30, 0.55)',
  surfaceHi:  'rgba(40, 40, 40, 0.75)',

  // Solid pre-blended equivalents (for views where backdrop-filter
  // produces visual artifacts — e.g. the timeline / gate views).
  surfaceSolid:   '#18191C',
  surfaceHiSolid: '#23252A',

  // ── Accent (priority gold) ────────────────────────────────────
  // Matches priority connection category + page brand.
  accent:    '#F9B612',
  accentDim: 'rgba(249, 182, 18, 0.3)',
  accentBg:  'rgba(249, 182, 18, 0.12)',

  // Pinned-1st / notes gold — slightly brighter shade used by
  // FlightTile for pinned & noted tiles. Distinct from accent.
  pinGold:   '#FFD700',
  pinGoldBg: 'rgba(255, 215, 0, 0.5)',

  // ── Connection categories (from connectionUtils.js) ──────────
  hot:     '#FF0000',                    // pure red, used for hot bag connections + danger
  hotBg:   'rgba(255, 0, 0, 0.2)',
  cold:    '#0277BD',                    // deep blue, cold connections
  coldBg:  'rgba(0, 0, 255, 0.2)',
  priority:    '#F9B612',                // alias of accent
  priorityBg:  'rgba(249, 182, 18, 0.3)',
  ok:      '#4CAF50',                    // confirm / accepted / outbound active
  okBg:    'rgba(76, 175, 80, 0.3)',
  warn:    '#F9B612',                    // alias of accent for "heads-up"
  danger:  '#FF0000',                    // alias of hot

  // ── Driver role chips (from FlightTile) ──────────────────────
  fwd:    '#2196F3',                     // FWD blue
  fwdBg:  'rgba(33, 150, 243, 0.3)',
  aft:    '#FF9800',                     // AFT orange
  aftBg:  'rgba(255, 152, 0, 0.3)',

  // ── Other category colors ────────────────────────────────────
  freight:    '#F6530F',
  freightBg:  'rgba(246, 83, 15, 0.3)',
  thru:       '#4CAF50',
  thruBg:     'rgba(76, 175, 80, 0.3)',
  overnight:  '#9C27B0',
  overnightBg:'rgba(156, 39, 176, 0.3)',
  cancelled:  '#FF1493',
  cancelledBg:'rgba(255, 20, 147, 0.4)',

  // ── Borders / dividers ───────────────────────────────────────
  border:       'rgba(255, 255, 255, 0.1)',
  borderStrong: 'rgba(255, 255, 255, 0.2)',
  divider:      'rgba(255, 255, 255, 0.12)',

  // ── Text ──────────────────────────────────────────────────────
  textPrimary:   '#e2e2e2',
  textSecondary: 'rgba(255, 255, 255, 0.7)',
  textMuted:     'rgba(255, 255, 255, 0.45)',
  textOnAccent:  '#000',

  // ── Effects ───────────────────────────────────────────────────
  blur: 'blur(10px)',
};
